import React, { useEffect, useState } from "react";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import { useFieldArray, useForm } from "react-hook-form";
import DeleteIcon from "../../../../components/Icons/DeleteIcon";
import { toast } from "react-toastify";
import { formatAmount, parseAmount } from "../../../../utility/CommonFunctions";
import { useNavigate } from "react-router-dom";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import EditItemModel from "./EditItemModel";
import { Spinner } from "reactstrap";
import ConfirmModal from "../../../../components/comman/ConfirmModal";
import BgBlurLoader from "../../../../components/Loaders/BgBlurLoader";

export default function SupplyServiceBudget({
  pageStates,
  type,
  ThirdFormSubmit,
  EditData = null,
  GetSiteBudgets,
  isLoading,
  budgetLoading,
  setBudgetLoading,
  initialTab = null,
}) {
  const {
    register,
    control,
    watch,
    setValue,
    getValues,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: {
      expenseHead: [
        {
          expenseheadId: "",
          expectedAmount: "",
          cashflowAmount: "",
          description: "",
        },
      ],
    },
  });
  const navigate = useNavigate();

  const {
    fields: fieldsSupply,
    append: appendSupply,
    remove: removeSupply,
  } = useFieldArray({
    control,
    name: "expenseHead",
  });
  const [model, setModel] = useState({
    editModel: false,
    deleteItemModel: false,
    deleteSectionModel: false,
  });
  const [state, setState] = useState({
    itemDetails: null,
    editItem: {
      expenseIndex: "",
      itemIndex: "",
      siteBudgetItemId: "",
    },
    isItemDeleteLoading: false,
  });
  // console.log("fieldsSupply==>", fieldsSupply)

  const toggleModel = (type, editItem) => {
    setModel((prev) => ({
      ...prev,
      [type]: !prev?.[type],
    }));
    if (type === "deleteItemModel" || type === "deleteSectionModel") {
      setState((prev) => ({
        ...prev,
        editItem: editItem
          ? editItem
          : {
            expenseIndex: "",
            itemIndex: "",
            siteBudgetItemId: "",
          },
      }));
    }
  };

  const watchItems = watch("expenseHead") || [];

  const fetchData = () => {
    setBudgetLoading(true);
    const expenseHead = EditData?.map((expense) => {
      return {
        cashflowAmount: expense?.cashflowAmount,
        expectedAmount: formatAmount(expense?.expectedAmount),
        expenseheadId: expense?.expenseheadId,
        description: expense?.description,
        siteBudgetId: expense?.id,
      };
    });
    reset({ expenseHead });
    setBudgetLoading(false);
  };

  useEffect(() => {
    // console.log("Service", pageStates)
    if (!EditData || pageStates?.expenseHeadList?.length === 0) {
      reset({
        expenseHead: [
          {
            expenseheadId: "",
            expectedAmount: "",
            cashflowAmount: "",
            description: "",
            siteBudgetId: "",
          },
        ],
      });
      setBudgetLoading(false);
      return;
    }

    fetchData();
  }, [EditData, pageStates?.expenseHeadList]);

  // Function to add new Expense Head
  const addExpenseHead = () => {
    appendSupply({
      expenseheadId: "",
      siteBudgetId: "",
      expectedAmount: "",
      cashflowAmount: "",
      description: "",
    });
  };

  // Form submission handler
  const onSubmit = (data) => {
    const amount = GetGrandTotal();

    if (amount == 0) {
      toast.info("Please fill all the Fields before submit");
      return;
    }

    const siteBudget = data?.expenseHead
      ?.filter((item) => !item?.siteBudgetId)
      ?.map((items) => ({
        cashflowAmount: items?.cashflowAmount,
        expectedAmount: parseAmount(items?.expectedAmount),
        expenseheadId: items?.expenseheadId,
        description: items?.description,
      }));

    if (type == "Supply Budget") {
      ThirdFormSubmit(siteBudget, "supplyBudget");
    } else if (type == "General Expense Head") {
      ThirdFormSubmit(siteBudget, "generalBudget");
    } else {
      ThirdFormSubmit(siteBudget, "serviceBudget");
    }
  };



  const handleDeleteSection = async (type = null, index) => {
    // toast.info("from api ");
    // console.log("siteBudgetId: ", siteBudgetId, "index: ", index, "isEdit: ", isEdit);
    if (type) {
      setState((prev) => ({
        ...prev,
        isItemDeleteLoading: true,
      }));
      const Url = `${apiUrl.delete_site_budget}?siteBudgetId=${state?.editItem?.siteBudgetItemId}`;
      callApi(Url, {
        method: "GET",
      }).then((response) => {
        setState((prev) => ({
          ...prev,
          isItemDeleteLoading: false,
        }));
        if (response?.status) {
          removeSupply(state?.editItem?.expenseIndex);
          toggleModel("deleteSectionModel");
        } else {
          toast.error(response?.message);
        }
      });
    } else {
      removeSupply(index);
    }
  };

  const GetGrandTotal = () => {
    let newGrandTotal = 0;
    watchItems.forEach((expense) => {
      newGrandTotal += parseAmount(expense.expectedAmount || "0");
    });
    return newGrandTotal;
  };

  const isItemFromEditData = (expenseheadId, itemId) => {
    if (!EditData || !expenseheadId || !itemId) return false;

    const matchingExpense = EditData.find(
      (head) => head.expenseheadId === expenseheadId
    );
    if (!matchingExpense) return false;

    return matchingExpense.sitebudgetitems?.some((i) => i.itemId === itemId);
  };

  return (
    <div>
      {budgetLoading ? (
        <BgBlurLoader />
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="col-12">
                <div className="col-12 d-flex justify-content-between rajdhani-semibold my-4 border-bottom pb-3">
                  <h4 className="fs-3 ">
                    {type == "General Expense Head" ? "General Budget" : type}
                  </h4>
                  <h4 className="fs-3 rajdhani-semibold">
                    Grand Total: {formatAmount(GetGrandTotal())}
                  </h4>
                </div>
                {fieldsSupply?.map((field, index) => {
                  const items = watch(`expenseHead.${index}.items`) || [];
                  const isAnyDeleteDisabled = items.some(
                    (item) =>
                      item?.freezedQuantity != null &&
                      item?.freezedQuantity != "0"
                  );
                  return (
                    <div
                      className="border rounded px-3 pt-3 mb-3"
                      key={field.siteBudgetId}
                    >
                      <div className="row align-items-start">
                        {/* Expense Head */}
                        <div className="col-12 col-md-4">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              {type == "Supply Budget"
                                ? "Expense Head"
                                : type === "General Expense Head"
                                  ? "General Expense Head"
                                  : "Service Type"}
                            </label>
                            <select
                              className="form-select form-control"
                              {...register(
                                `expenseHead.${index}.expenseheadId`,
                                {
                                  required: "This field is required",
                                }
                              )}
                              onChange={(e) => { }}
                              disabled={EditData?.some(
                                (item) =>
                                  item.expenseheadId ===
                                  watch(`expenseHead.${index}.expenseheadId`)
                              )}
                            >
                              <option value="" className="d-none">
                                Select{" "}
                                {type === "Supply Budget"
                                  ? "Expense Head"
                                  : type === "General Expense Head"
                                    ? "General Expense Head"
                                    : "Service Type"}
                              </option>
                              {pageStates?.expenseHeadList?.map((item) => {
                                const isDisabled = fieldsSupply?.some(
                                  (expense) =>
                                    expense?.expenseheadId === item.id
                                );
                                return (
                                  <option
                                    key={item.id}
                                    value={item.id}
                                    disabled={isDisabled}
                                  >
                                    {item.name}
                                  </option>
                                );
                              })}
                            </select>

                            {errors?.expenseHead?.[index]?.expenseheadId && (
                              <div className="form-text text-danger">
                                {
                                  errors.expenseHead[index].expenseheadId
                                    .message
                                }
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Expected Amount */}
                        <div className="col-12 col-md-2">
                          <div className="form-group mb-3">
                            <label className="form-label">
                              Expected Amount
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              {...register(
                                `expenseHead.${index}.expectedAmount`,
                                {
                                  required: "This field is required",
                                }
                              )}
                              disabled={!!EditData}
                              onChange={(e) => {
                                let value = e.target.value
                                  .replace(/[^0-9.]/g, "")
                                  .replace(/(\..*)\./g, "$1");
                                if (!/^\d*\.?\d*$/.test(value))
                                  value = "";
                                e.target.value = value;
                              }}
                            />
                            {errors?.expenseHead?.[index]?.expectedAmount && (
                              <div className="form-text text-danger">
                                {errors.expenseHead[index].expectedAmount.message}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Description */}
                        <div className="col-12 col-md-4">
                          <div className="form-group mb-3">
                            <label className="form-label">Description</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter description"
                              {...register(`expenseHead.${index}.description`)}
                              disabled={!!EditData}
                            />
                            {errors?.expenseHead?.[index]?.description && (
                              <div className="form-text text-danger">
                                {errors.expenseHead[index].description.message}
                              </div>
                            )}
                          </div>
                        </div>
                        {!EditData && (
                          <div className="col-12 col-md-2">
                            <div className="form-group mb-3">
                              <label className="form-label d-none d-md-block">&nbsp;</label>
                              <button
                                className="btn btn-outline-danger w-50 py-2"
                                type="button"
                                onClick={() => {
                                  if (watch(`expenseHead.${index}.siteBudgetId`)) {
                                    const editItemData = {
                                      expenseIndex: index,
                                      siteBudgetItemId: watch(
                                        `expenseHead.${index}.siteBudgetId`
                                      ),
                                      itemIndex: "",
                                    };
                                    toggleModel("deleteSectionModel", editItemData);
                                  } else {
                                    handleDeleteSection(null, index);
                                  }
                                }}
                                disabled={EditData}
                              >
                                <DeleteIcon /> Remove
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
              {/* Add Expense Head Button */}
              {!EditData && (<div className="col text-end">
                <button
                  className="btn btn-primary py-2 fw-bold"
                  type="button"
                  onClick={addExpenseHead}
                >
                  <span className="bg-light">
                    <PlusIcon />
                  </span>{" "}
                  Add Section
                </button>
              </div>)}
              {/* Submit Button */}
              {watch("expenseHead")?.some((item) => !item?.siteBudgetId) && (
                <div className="d-flex align-items-center justify-content-end gap-4 mt-4">
                  <button
                    className="btn btn-secondary px-4"
                    type="button"
                    onClick={() => navigate(-1)}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary px-4" type="submit">
                    {isLoading ? <Spinner /> : "Save"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </form>
      )}
      <ConfirmModal
        modal={model.deleteSectionModel}
        toggle={() => toggleModel("deleteSectionModel")}
        submitHandler={() => handleDeleteSection("deleteSectionModel")}
        isLoading={state.isItemDeleteLoading}
      />
    </div>
  );
}
